"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffectEventHandlerActivator = exports.ApplyEffectEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class ApplyEffectEventHandlerArgs {
    constructor(source, target, duration, effect, supernatural = false, livingOnly = false) {
        this.source = source;
        this.target = target;
        this.duration = duration;
        this.effect = effect;
        this.supernatural = supernatural;
        this.livingOnly = livingOnly;
        this.__type = EventHandlerType_1.EventHandlerType.ApplyEffect;
        this.__typeName = "ApplyEffect";
    }
}
exports.ApplyEffectEventHandlerArgs = ApplyEffectEventHandlerArgs;
let ApplyEffectEventHandlerActivator = class ApplyEffectEventHandlerActivator {
    activate(sequence, container, handler) {
        const sourceIds = typeof handler.args.source === "number" ? [handler.args.source]
            : container.selectLivingTargets(handler.subject, handler.args.source);
        sourceIds.forEach(sourceId => {
            const targets = container.selectTargets(sourceId, handler.args.target);
            if (handler.args.effect.harmful) {
                targets.forEach(targetId => container.applyDebuff({
                    attackerId: sourceId,
                    targetId,
                    duration: handler.args.duration,
                    effect: handler.args.effect,
                    supernatural: handler.args.supernatural,
                    sequence
                }));
            }
            else {
                targets.forEach(targetId => container.applyBuff({
                    creatorId: sourceId,
                    targetId,
                    duration: handler.args.duration,
                    effect: handler.args.effect,
                    supernatural: handler.args.supernatural,
                    sequence
                }));
            }
        });
    }
};
ApplyEffectEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.ApplyEffect)
], ApplyEffectEventHandlerActivator);
exports.ApplyEffectEventHandlerActivator = ApplyEffectEventHandlerActivator;
